import type { DocumentTemplate } from 'modules/documents/hooks/useGetDocumentTemplates'
import type Variable from 'modules/documents/store/models/Variable'

export type VariablesAccess = 'full' | 'no_access' | 'partial'

const getVariablesAccess = (
  documentTemplate: DocumentTemplate,
  templateVariables: Variable[]
): VariablesAccess => {
  let noAccess = 0
  let partialAccess = 0

  const filteredVariables = templateVariables.filter((variable) =>
    documentTemplate.values!.includes(variable.attributes.variable)
  )

  for (const variable of filteredVariables) {
    if (variable.attributes.access == 'no_access') {
      noAccess += 1
      break
    }
    if (variable.attributes.access == 'partial') {
      partialAccess += 1
    }
  }

  if (noAccess > 0) {
    return 'no_access'
  } else if (partialAccess > 0) {
    return 'partial'
  }

  return 'full'
}

export default getVariablesAccess
